import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import LEOfferCard from 'tripPlanner/components/Bookmark/BookmarkCard/LEOfferCard'
import { isBedbank, isLEOffer, isTourOffer } from 'lib/offer/offerTypes'
import TourBookmarkCard from 'tripPlanner/components/Bookmark/BookmarkCard/TourBookmarkCard'
import { connect } from 'react-redux'
import BedbankCard from 'tripPlanner/components/Bookmark/BookmarkCard/BedbankCard'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/OfferListEventsContext'
import { useInView } from 'react-intersection-observer'
import { OFFER_TRACKING_IN_VIEW_THRESHOLD } from 'constants/offerList'

interface Props {
  offer: App.Offer
  position?: number
}

export const CARD_WIDTH = 273

const SmallerTourCard = styled(TourBookmarkCard)`
  width: 75vw;
  ${mediaQueryUp.tablet} {
    width: ${rem(CARD_WIDTH)};
  }
`

const SmallerLEOfferCard = styled(LEOfferCard)`
  width: 75vw;
  ${mediaQueryUp.tablet} {
    width: ${rem(CARD_WIDTH)};
  }
`

const SmallerBedbankCard = styled(BedbankCard)`
  width: 75vw;
  ${mediaQueryUp.tablet} {
    width: ${rem(CARD_WIDTH)};
  }
`

function StandaloneLocationSeededYmalListOffer(props: Props) {
  const { offer, position } = props

  const [inViewRef, hasBeenInView] = useInView({
    triggerOnce: true,
    threshold: OFFER_TRACKING_IN_VIEW_THRESHOLD,
  })

  const dispatchOfferListEvent = useContext(OfferListEventsContext)
  useEffect(() => {
    if (hasBeenInView && position !== undefined) {
      dispatchOfferListEvent({
        type: OfferListEvents.productImpression,
        offer,
        position,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Only
  }, [hasBeenInView, offer])

  if (isLEOffer(offer)) {
    if (isTourOffer(offer)) {
      return <SmallerTourCard position={position} offer={offer}
      target="_blank" ref={inViewRef}/>
    }
    return <SmallerLEOfferCard position={position} offer={offer}
    target="_blank" ref={inViewRef}/>
  } else if (isBedbank(offer)) {
    return <SmallerBedbankCard position={position} offer={offer}
    target="_blank"
    ref={inViewRef}/>
  }
  return null
}

function mapState(state: App.State) {
  return {
    currency: state.geo.currentCurrency,
  }
}

export default connect(mapState)(StandaloneLocationSeededYmalListOffer)
